export const SupportIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 12.5C17 12.942 16.824 13.366 16.512 13.678C16.2 13.99 15.776 14.166 15.334 14.166H6.667L3 17.833V4.833C3 4.391 3.176 3.967 3.488 3.655C3.8 3.343 4.224 3.167 4.666 3.167H15.333C15.775 3.167 16.199 3.343 16.511 3.655C16.823 3.967 16.999 4.391 16.999 4.833L17 12.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
